<template>
  <div class="about-m content-part">
    <div class="banner">
      <img :src="currentLg.banner" alt="" />
    </div>
    <div class="aboutUs">
      <el-tabs v-model="type">
        <el-tab-pane
          v-for="(i, index) in btnList"
          :key="index"
          :label="i[`name_${locale}`]"
          :name="index + 1 + ''"
        ></el-tab-pane>
      </el-tabs>
      <template v-if="type == '1'">
        <div class="box">
          <div class="intro">
            <div class="right-info">
              <h4>{{ currentLg.intro }}</h4>
              <img class="mb2" src="./../assets/img/line.png" alt="" />
              <div class="lists">
                <p v-for="(i, index) in intro" :key="index">
                  {{ i[`name_${locale}`] }}
                </p>
              </div>
            </div>
            <div class="left-img">
              <img src="./../assets/images/about/intro.png" alt="" />
            </div>
          </div>
          <div class="honor">
            <h4>{{ currentLg.honor }}</h4>
            <img class="mb2" src="./../assets/img/line.png" alt="" />
            <swiper :options="mySwiperOption">
              <swiper-slide v-for="(item, index) in imgList" :key="index">
                <div class="imgList">
                  <img
                    v-for="(i, idx) in item"
                    :key="idx"
                    class="w200"
                    :src="require(`./../assets/images/about/${i}.jpg`)"
                    width="100%"
                  />
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="prod">
            <h4>{{ currentLg.knowledge }}</h4>
            <img class="mb2" src="./../assets/img/line.png" alt="" />
            <div class="knowledge">
              <div class="flex">
                <img src="./../assets/images/about/17.jpg" alt="" />
                <img src="./../assets/images/about/18.jpg" alt="" />
                <img
                  class="dizuo"
                  src="./../assets/images/about/19.png"
                  alt=""
                />
              </div>
              <img
                class="zhishi"
                src="./../assets/images/about/knowledge.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="cotent-airtical">
          <div class="linkUs">
            <div class="linkWay">
              <div class="item" v-for="(i, index) in companyInfo" :key="index">
                <img
                  :src="require(`./../assets/images/about/${index + 1}.png`)"
                  alt=""
                />
                <div class="right-cn">
                  <p class="p-title">{{ i[`title_${locale}`] }}</p>
                  <p class="p-name">{{ i[`name_${locale}`] }}</p>
                </div>
              </div>
            </div>
          </div>
          <p class="ewm">
            <img src="../assets/img/ewm3.jpg" />
          </p>
        </div>
        <baidu-map
          class="map"
          :center="{ lng: 113.948357, lat: 22.533454 }"
          :zoom="15"
          :scroll-wheel-zoom="true"
        >
          <bm-marker
            :position="{ lng: 113.948357, lat: 22.533454 }"
            :dragging="true"
          >
            <bm-info-window
              :position="{ lng: 113.948357, lat: 22.533454 }"
              :show="infoWindow.show"
            >
              <p>{{ currentLg[`address_${locale}`] }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map>
      </template>
    </div>
  </div>
</template>
<script>
import language from "./../language/about/index";
export default {
  data() {
    return {
      type: "1",
      intro: [
        {
          name_CN:
            "金马节能科技（深圳）有限公司（以下简称“金马节能”），致力于成为国内领先的专业综合二次能源供应商。公司聚焦工业领域及大型公共建筑，为客户提供蒸汽、压缩空气、冷冻水、冷却水等二次能源的生产、输配与智慧运维服务。立足深圳，设上海、北京分部，济南子公司，业务辐射全国。",
          name_EN:
            "BLEMS is committed to becoming a leading professional comprehensive secondary energy supplier in China. The company focuses on the industrial sector and large-scale public buildings, providing customers with services encompassing the production, transmission, distribution, and smart operation & maintenance of secondary energy sources such as steam, compressed air, chilled water, and cooling water. Headquartered in Shenzhen, the company has established branches in Shanghai and Beijing, and a subsidiary in Jinan, with its business radiating across the country.",
        },
        {
          name_CN:
            "金马节能是典型的产、学、研一体化发展平台，核心技术团队曾就职于清华大学建筑节能研究中心、上海市建筑科学研究院等国内知名科研机构。公司与国家节能中心、建设部科技发展促进中心、同济大学设施管理研究院（FM）、国际建筑业主与管理者协会（BOMA）保持深度合作，持续推动二次能源系统的能效技术研发与软件平台迭代。",
          name_EN:
            "BLEMS operates as a typical platform integrating production, education, and research. Its core technical team members have previously worked at renowned domestic research institutions like the Building Energy Research Center of Tsinghua University and the Shanghai Research Institute of Building Sciences. The company maintains deep collaborations with the National Energy Conservation Center, the Science and Technology Development Promotion Center of the Ministry of Housing and Urban-Rural Development, the Facilities Management Institute (FM) of Tongji University, and the Building Owners and Managers Association (BOMA) International, continuously advancing energy efficiency technology research and software platform iteration for secondary energy systems.",
        },
        {
          name_CN:
            "公司提供从能源站规划、建设到智慧运维的全生命周期解决方案。以“持续为业主创造新的利润中心”为宗旨，坚持实测数据说话，以“效果保障型”服务实现立竿见影的节能收益。通过优化二次能源系统效率，金马节能已为业主带来数亿计的能源成本节约、用能体验升级与资产增值。",
          name_EN:
            'The company provides full lifecycle solutions, ranging from energy station planning and construction to smart operation and maintenance. Guided by the principle of "continuously creating new profit centers for property owners," BLEMS insists on using measured data and delivers immediate energy-saving benefits through "performance-guaranteed" services. By optimizing the efficiency of secondary energy systems, BLEMS has generated hundreds of millions in energy cost savings for its clients, along with enhanced energy consumption experiences and asset appreciation.',
        },
        {
          name_CN:
            "金马节能，以科技赋能二次能源，致力成为智慧能源系统领跑者，以ESG理念支撑全面高质量发展。",
          name_EN:
            "BLEMS empowers secondary energy with technology, striving to become a leader in smart energy systems and supporting comprehensive, high-quality development with ESG principles.",
        },
      ],
      companyInfo: [
        {
          title_CN: "联系方式",
          name_CN: "0755-83239076",
          title_EN: "Contact",
          name_EN: "(+86) 0755-83239076",
        },
        {
          title_CN: "邮箱",
          title_EN: "E-mail",
          name_CN: "BLEMS@goldhorse-energy.com",
          name_EN: "BLEMS@goldhorse-energy.com",
        },
        {
          title_CN: "深圳总部",
          title_EN: "Shenzhen Headquarter",
          name_CN: "深圳市南山区高新南九道西北工业大学三航科技大厦2105",
          name_EN:
            "Room 2105, Sanhang Science & Technology Building, Northwestern Polytechnical University, Gaoxin South 9th Road, Nanshan District, Shenzhen, China",
        },
      ],
      btnList: [
        { name_CN: "公司简介", name_EN: "Company Profile" },
        { name_CN: "联系我们", name_EN: "Contact Us" },
      ],
      imgList: [
        [1, 2, 3, 4, 11, 12],
        [5, 6, 7, 8, 13, 14],
        [9, 10, 15, 16],
      ],
      mySwiperOption: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        //自动播放
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        //循环
        loop: true,
      },
      infoWindow: {
        show: true,
      },
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  watch: {
    locale() {
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-tabs__active-bar {
  background: #1289d9 linear-gradient(90deg, #1289d9, #76dcc7);
}
.el-tabs {
  padding: 0 4vw;
}
/deep/ .el-tabs__item {
  font-size: 4vw;
  line-height: 5vh;
  height: 5vh;
}
.map {
  width: 100%;
  height: 40vh;
}
.about {
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.box {
  color: #666;

  .intro {
    margin: 4vh 5vw;
    .left-img {
      width: 80vw;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .right-info {
      text-align: center;
      h4 {
        text-align: center;
      }
    }
  }
}
.mb2 {
  margin-bottom: 2vh;
}
.lists {
  margin-bottom: 2vh;
}
h4 {
  font-size: 5vw;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #2a2a2a;
  margin-bottom: 3vh;
}
.lists p {
  padding-bottom: 2vh;
  line-height: 5vh;
  text-indent: 5vh;
  color: #666;
  font-size: 4vw;
}

.linkUs {
  display: flex;
  justify-content: space-between;
  .linkWay {
    font-size: 5vw;
    color: #666666;
    flex: 1;
    .item {
      display: flex;
      align-items: center;
      padding: 2vh 8vw;
      .right-cn {
        flex: 1;
      }
      img {
        height: 10vw;
        margin-right: 8vw;
      }
    }
    .p-title {
      font-size: 5vw;
      font-family: SourceHanSansCN;
      font-weight: bold;
      color: #2a2a2a;
      line-height: 8vh;
    }
    .p-name {
      font-size: 4vw;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #2a2a2a;
      line-height: 5vh;
    }
  }
}
.ewm {
  display: flex;
  justify-content: center;
  img {
    height: 50vw;
  }
}
.honor {
  background: #f0f0f0;
  text-align: center;
  padding: 0 6vw;
  h4 {
    text-align: center;
    padding-top: 4vh;
  }
}
.honor-list {
  margin-top: 10vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 3vw;
}
.w200 {
  width: 40vw;
  margin: 0 1.8vw;
}
.prod {
  text-align: center;
  padding: 0 5vw;
  h4 {
    text-align: center;
    padding-top: 4vh;
  }
}

.knowledge {
  img {
    width: 100%;
  }
  .flex {
    display: flex;
    margin: 0 auto;
    justify-content: space-around;
    margin-bottom: 5vh;
    position: relative;
    img {
      width: 25vw;
      height: 22vh;
      margin-right: 3vw;
      z-index: 1;
    }
    .dizuo {
      z-index: 0;
      position: absolute;
      width: 80vw;
      height: 6vh;
      bottom: -3vh;
    }
  }
  .zhishi {
    margin-top: 4vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about_m.vue